import { render, staticRenderFns } from "./ProjectGroupDetailsDocuments.vue?vue&type=template&id=68e90f75&"
import script from "./ProjectGroupDetailsDocuments.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupDetailsDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports